<template>
  <div
    class="po-order _tabs"
    v-if="order"
  >
    <div class="po-order__header po-order__header_detail">
        <div>
            <div
              class="po-order__status po-order__status_done"
              v-if="order.completion_date"
            >
              Выполнен <span>{{ order.completion_date | formatDate }}</span>
            </div>
            <div class="po-order__title">Заказ №{{ order.id }}<span>От {{ order.date | formatDate }}</span></div>
            <div class="po-order__text">
                Информация о составе заказа представлена на вкладке “Заказ”. Контактная информация, добавленная при оформлении заказа, указана на вкладке “Контакты”
            </div>
        </div>
        <div>
            <div class="tabs-buttons _tabs__buttons">
                <div
                  class="tabs-buttons__btn _tabs__btn"
                  v-bind:class="{'_active': selectedTab == 1}"
                  @click="selectedTab = 1"
                >
                  Заказ
                </div>
                <div
                  class="tabs-buttons__btn _tabs__btn"
                  v-bind:class="{'_active': selectedTab == 2}"
                  @click="selectedTab = 2"
                >
                  Контакты
                </div>
            </div>
        </div>
    </div>
    <transition name="slide-fade">
      <div
        class="tabs-body _tabs__body _active"
        v-if="selectedTab == 1"
      >
          <div
            class="order"
            v-for="item in order.order_items"
            v-bind:key="item.id"
          >
              <div class="order__title">
                  <div class="order__brand">{{ item.brand_name }}</div>
                  <div class="title-m">{{ item.brand_calculator_name }}</div>
              </div>
              <div class="order__item">
                  <div class="order__icon">
                      <img
                        class="order__img"
                        v-bind:src="item.icon"
                        v-bind:alt="item.furniture_category_name">
                  </div>
                  <div class="order__item-title">
                      <div>{{ item.furniture_category_name }}</div>
                      <div class="order__item-title-tags">
                          <span
                            v-if="item.furniture_series"
                          >
                            {{ item.furniture_series_name }}
                          </span>
                          <span
                            v-if="item.furniture_type">
                            {{ item.furniture_type_name }}
                          </span>
                      </div>
                  </div>
                  <div class="order__info">
                      <div
                        class="order__info-block"
                        v-if="item.quantity"
                      >
                        {{ item.quantity }} шт
                      </div>
                      <div
                        class="order__info-block"
                        v-if="item.price"
                      >
                        {{ item.price | splitNumber }} руб<!--/шт-->
                      </div>
                      <div class="order__info-block order__info-block_last">
                          Стоимость услуги:
                          <span>{{ item.cost | splitNumber }} руб</span>
                      </div>
                  </div>
              </div>
              {{ order.order_services }}
              <template v-if="item.order_services && item.order_services.length">
                <div
                    class="payment-service"
                    v-for="(service, index) in item.order_services"
                    v-bind:key="service.id"
                >
                    <div class="payment-service__block payment-service__block_name">
                        <div
                            class="payment-service__block-label"
                            v-if="index == 0"
                        >
                            Дополнительные услуги
                        </div>
                        <div class="payment-service__block-text">
                          {{ service.service_name }}
                        </div>
                    </div>
                    <div
                        class="payment-service__block"
                        v-if="service.quantity"
                    >
                        <div class="payment-service__block-label">
                            Количество
                        </div>
                        <div class="payment-service__block-text">
                            {{ service.quantity }} шт
                        </div>
                    </div>
                    <div
                        class="payment-service__block"
                        v-if="service.cost_per_unit"
                    >
                        <div class="payment-service__block-label">
                            Стоимость за шт
                        </div>
                        <div class="payment-service__block-text">
                            {{ service.cost_per_unit | splitNumber }} руб
                        </div>
                    </div>
                    <div
                        class="payment-service__block"
                        v-if="service.price"
                    >
                        <div class="payment-service__block-label">
                            Стоимость
                        </div>
                        <div class="payment-service__block-text">
                            {{ service.price | splitNumber }} руб
                        </div>
                    </div>
                    <div class="payment-service__block payment-service__block_cost">
                        <div class="payment-service__block-label">
                            Стоимость услуги:
                        </div>
                        <div class="payment-service__block-text">
                            {{ service.service_cost | splitNumber }} руб
                        </div>
                    </div>
                </div>
            </template>
          </div>
          <div class="po-order__price">
              <div class="title-m">Общая стоимость:</div>
              <div>
                  <div class="title-m">{{ order.total_cost | splitNumber }} руб</div>
                  <span>Включая НДС</span>
              </div>
          </div>
      </div>
    </transition>
    <transition name="slide-fade">
      <div
        class="tabs-body _tabs__body _active"
        v-if="selectedTab == 2"
      >
          <div class="po-data">
              <div class="title-m">Личные данные</div>
              <div class="po-data__line">
                  <div
                    class="po-data__block"
                    v-if="order.name"
                  >
                    <div class="po-data__label">Имя</div>
                    <div class="po-data__text">{{ order.name }}</div>
                  </div>
                  <div
                    class="po-data__block"
                    v-if="order.email"
                  >
                    <div class="po-data__label">Email</div>
                    <div class="po-data__text">{{ order.email }}</div>
                  </div>
                  <div class="po-data__block">
                    <div class="po-data__label">Ваш телефон</div>
                    <div class="po-data__text">{{ order.phone }}</div>
                  </div>
              </div>
              <div class="po-data__line">
                  <div
                    class="po-data__block"
                    v-if="order.street"
                  >
                    <div class="po-data__label">Улица</div>
                    <div class="po-data__text">{{ order.street }}</div>
                  </div>
                  <div
                    class="po-data__block"
                    v-if="order.house"
                  >
                    <div class="po-data__label">Дом</div>
                    <div class="po-data__text">{{ order.house }}</div>
                  </div>
                  <div
                    class="po-data__block"
                    v-if="order.flat"
                  >
                    <div class="po-data__label">Квартира</div>
                    <div class="po-data__text">{{ order.flat }}</div>
                  </div>
              </div>
              <div class="po-data__line">
                  <div
                    class="po-data__block"
                    v-if="order.order_date"
                  >
                    <div class="po-data__label">Предпочительная дата</div>
                    <div class="po-data__text">{{ order.order_date }}</div>
                  </div>
                  <div
                    class="po-data__block"
                    v-if="order.order_time"
                  >
                    <div class="po-data__label">Время</div>
                    <div class="po-data__text">{{ order.order_time }}</div>
                  </div>
                  <div class="po-data__block">
                      <div class="po-data__label">Предпочительный способ оплаты</div>
                      <div  class="po-data__text po-data__text_flex">
                        <template v-if="order.payment_type == 1">
                          <!--
                          <svg class="svg-card-dims">
                              <use xlink:href="../assets/img/svg/sprite-symbol.svg#card"></use>
                          </svg>
                          -->
                          Банковской картой
                        </template>
                        <template v-if="order.payment_type == 2">
                          <!--
                          <svg class="svg-card-dims">
                              <use xlink:href="../assets/img/svg/sprite-symbol.svg#file"></use>
                          </svg>
                          -->
                          Наличными
                        </template>
                      </div>
                  </div>
              </div>
          </div>
      </div>
    </transition>
</div>
</template>

<script>

import { Order } from '@/api/order';

export default {
  name: 'home',
  data: function() {
    return {
      selectedTab: 1,
      order: null
    }
  },
  mounted: function() {
    Order.order(this.$route.params.id).then(response => {
        this.order = response.data;
    });
  },
}
</script>
<style lang="scss">
  .order__img {
    height: 50px;
  }
  .payment-service {
    background-color: transparent;
    border-bottom: 1px solid #cacaca;
    &:last-of-type {
      border-bottom: none;
    }
  }
  .po-order__price {
    padding: 5px;
  }
  .po-data__text svg {
    margin-right: 10px;
  }


  @media screen and (max-width: 768px) {
    .order__item-title-tags {
      display: block;
      & span {
        display: block;
      }
    }
  }
    
</style>